import { render, staticRenderFns } from "./RecepcionContenedorComponent.vue?vue&type=template&id=158eaf61&"
import script from "./RecepcionContenedorComponent.vue?vue&type=script&lang=js&"
export * from "./RecepcionContenedorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports